export default __webpack_public_path__ + "static/media/clarity-vs2.40e52294.webp";